export const EXTERNAL_RESOURCE_CONTENT_TYPE = "web_search_result";
